import * as React from "react";

export const ElementLink = ({ link, text, new_tab = false }) => {
    return (
        <a href={link} target={new_tab ? "_blank" : "_self"} rel={new_tab ? "noopener noreferrer" : undefined}>{text}</a>
    );
};